module.exports = __webpack_public_path__ + "img/logo11.c4185e49.png";